var React = require('react');

function IconSocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 20.11C0 30.06 7.22 38.32 16.67 40V25.55h-5V20h5v-4.45c0-5 3.22-7.77 7.77-7.77 1.45 0 3 .22 4.45.44v5.11h-2.56c-2.44 0-3 1.22-3 2.78V20h5.34l-.9 5.55h-4.44V40A20.24 20.24 0 0040 20.11C40 9.05 31 0 20 0S0 9.05 0 20.11z","fill":"#3B5998"}));
}

IconSocialFacebook.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 40 40"};

module.exports = IconSocialFacebook;

IconSocialFacebook.default = IconSocialFacebook;
